if (!customElements.get('ss-project-gallery')) {
  customElements.define('ss-project-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const track = this.querySelector('.ss-project-gallery__track');
      const slides = [...this.querySelectorAll('.ss-project-gallery__slide')];
      const dialog = this.querySelector('dialog');
      const full = dialog.querySelector('img');
      let selected = 0;
      const update = () => {
        this.querySelectorAll('.ss-project-gallery__count').forEach(c => c.textContent = (selected + 1) + ' / ' + slides.length);
      };
      const show = index => {
        selected = (index + slides.length) % slides.length;
        full.src = slides[selected].dataset.fullSrc;
        full.alt = slides[selected].querySelector('img').alt;
        update();
      };
      const move = step => {
        const index = Math.round(track.scrollLeft / track.clientWidth);
        const next = (index + step + slides.length) % slides.length;
        track.scrollTo({left: next * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      this.querySelectorAll('[data-step]').forEach(b => b.addEventListener('click', () => move(Number(b.dataset.step))));
      track.addEventListener('scroll', () => { if (!dialog.open) { selected = Math.round(track.scrollLeft / track.clientWidth); update(); } }, {passive:true});
      track.addEventListener('keydown', e => { if(e.key === 'ArrowRight' || e.key === 'ArrowLeft') {e.preventDefault();move(e.key === 'ArrowRight' ? 1 : -1);} });
      slides.forEach((b,i) => b.addEventListener('click', () => {show(i);dialog.showModal();}));
      dialog.querySelector('[data-close]').addEventListener('click', () => dialog.close());
      dialog.querySelectorAll('[data-lightbox-step]').forEach(b => b.addEventListener('click', () => show(selected + Number(b.dataset.lightboxStep))));
      dialog.addEventListener('keydown', e => {if(e.key === 'ArrowRight' || e.key === 'ArrowLeft') {e.preventDefault();show(selected + (e.key === 'ArrowRight' ? 1 : -1));}});
      dialog.addEventListener('click', e => {if(e.target === dialog) {const r=dialog.getBoundingClientRect();if(e.clientX<r.left || e.clientX>r.right || e.clientY<r.top || e.clientY>r.bottom) dialog.close();}});
      dialog.addEventListener('close', () => {track.scrollTo({left:selected * track.clientWidth,behavior:'instant'});});
      update();
    }
    disconnectedCallback() { const d=this.querySelector('dialog');if(d?.open)d.close(); }
  });
}
